// extracted by mini-css-extract-plugin
export default {"wrapper":"Kt-z","response":"Lt-z","error":"Mt-z","disabled":"Nt-z","buttons":"Ot-z","feedbackQuestionSection":"Pt-z","yesNoWrapper":"Qt-z"};